import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from "@angular/core";
import { MenuItem } from "@obg/ngx.core.content";

@Component({
	selector: "obg-m-content-menu-items",
	templateUrl: "./content-menu-items.component.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class ContentMenuItemsComponent {
	@Input() menuItems: MenuItem[] | undefined;

	@Output() selectedItem = new EventEmitter<string>();

	trackByItem(_index: number, item: MenuItem) {
		return item.key;
	}
}
